import i18n from '@src/common/lib/i18n'
export const deviceTableOption = function(cameraFeatureShow, menuShow) {
  if(cameraFeatureShow) {
    console.log('cameraFeatureShow', cameraFeatureShow)
    return {
      stripe: true,
      page: true,
      maxHeight: '100%',
      align: 'center',
      header: false,
      selection: true,
      emptyText: i18n.t('cameraList.title.noData'),
      delBtn: false,
      editBtn: false,
      menu: false,
      column: [
        {
          label: i18n.t('cameraList.label.deviceName'),
          prop: 'deviceName',
          align: 'center',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.deviceId'),
          prop: 'deviceId',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.ip'),
          prop: 'ip',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.port'),
          prop: 'port',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.systemName'),
          prop: 'systemName',
          align: 'center',
          overHidden: true
        },
        // {
        //   label: i18n.t('cameraList.label.deviceType'),
        //   prop: 'cameraTypeName',
        //   overHidden: true,
        //   align: 'center'
        // },
        {
          label: i18n.t('cameraList.label.factory'),
          prop: 'factoryName',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.areaName'),
          prop: 'areaName',
          align: 'center',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.statusName'),
          prop: 'statusName',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.attribute'),
          prop: 'cameraFeatureName',
          // overHidden: true,
          slot: true
        },
        {
          label: i18n.t('cameraList.label.synTime'),
          prop: 'createrTime',
          // overHidden: true,
          slot: true
        },
        {
          label: i18n.t('cameraList.label.operate'),
          prop: 'operate',
          hide: !menuShow,
          slot: true
        }

      ]
    }
  } else {
    return {
      stripe: true,
      page: true,
      maxHeight: '100%',
      align: 'center',
      header: false,
      selection: true,
      emptyText: i18n.t('cameraList.title.noData'),
      delBtn: false,
      editBtn: false,
      menu: false,
      column: [
        {
          label: i18n.t('cameraList.label.deviceName'),
          prop: 'deviceName',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.doorId'),
          prop: 'thirdDeviceId',
          overHidden: true,
        },
        {
          label: i18n.t('cameraList.label.deviceId'),
          prop: 'deviceId',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.systemName'),
          prop: 'systemName',
          // align: 'left',
          overHidden: true
        },
        // {
        //   label: i18n.t('cameraList.label.deviceType'),
        //   prop: 'deviceTypeName',
        //   overHidden: true,
        // },
        {
          label: i18n.t('cameraList.label.factory'),
          prop: 'factoryName',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.areaName'),
          prop: 'areaName',
          // align: 'left',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.statusName'),
          prop: 'statusName',
          overHidden: true
        },
        {
          label: i18n.t('cameraList.label.operate'),
          prop: 'operate',
          hide: cameraFeatureShow,
          slot: true
        }
      ]
    }
  }
}
